var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToDo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1206",
    d: "M0 0h32v32H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1207",
    d: "M28.667 20.667v-16A2.675 2.675 0 0 0 26 2H10a2.675 2.675 0 0 0-2.667 2.667v16A2.675 2.675 0 0 0 10 23.333h16a2.675 2.675 0 0 0 2.667-2.666zM14.533 16.04l2.173 2.907 3.44-4.293a.666.666 0 0 1 1.04 0l3.947 4.933a.664.664 0 0 1-.52 1.08h-13.28A.666.666 0 0 1 10.8 19.6l2.667-3.56a.677.677 0 0 1 1.067 0zM2 8.667V26a2.675 2.675 0 0 0 2.667 2.667H22A1.333 1.333 0 0 0 22 26H6a1.337 1.337 0 0 1-1.333-1.333v-16a1.333 1.333 0 1 0-2.667 0z",
    transform: "translate(.667 .667)",
    style: {
      fill: "#ea7d36",
      stroke: "#1f0f04",
      strokeWidth: ".8px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDo);
export default __webpack_public_path__ + "static/media/to-do.20ad54898d324bb7ac322d8d98b02bc8.svg";
export { ForwardRef as ReactComponent };